<template>
  <header
    :class="[
      'header-area bg-white text-center text-md-start pt-15 pb-15 ps-15 pe-15 ps-md-20 pe-md-20 pe-lg-30 transition mb-25 position-fixed radius-7',
      { sticky: isSticky },
    ]"
    id="header"
  >
    <div class="custom-pre-header">
      <div class="d-flex justify-content-center justify-content-md-start">
        <div class="header-left-side justify-content-center justify-content-md-start d-flex align-items-center">
          <button
            class="header-burger-menu transition position-relative lh-1 bg-transparent p-0 border-0"
            id="header-burger-menu"
            @click="stateStoreInstance.onChange"
          >
            <i class="flaticon-menu-3"></i>
          </button>
          <span class="header-context">Financeiro</span>
        </div>
      </div>

      <div class="custom-options-right d-flex">
        <div class="header-right-side d-flex align-items-center justify-content-center">
          <LightDarkSwtichBtn />
        </div>

        <div class="profile-dropdown d-flex justify-content-end">
          <button
            class="text-end fs-14 text-black-emphasis d-flex align-items-center p-0 position-relative bg-transparent border-0 transition lh-1"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <span class="title d-lg-block">
              <span class="d-block fw-bold">{{ getConfigurations.name || 'Minha conta' }}</span>
              <span class="text-body-emphasis fw-semibold fs-13">Conta</span>
            </span>
          </button>

          <div class="dropdown dropdown-menu rounded-0 bg-white border-0 end-0 ps-10 radius-7">
            <ul class="ps-0 mb-0 list-unstyled dropdown-body">
              <li class="text-body-secondary fw-semibold transition position-relative">
                <i class="flaticon-setting"></i>
                Configuracoes
                <router-link
                  to="/configurations"
                  class="d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                ></router-link>
              </li>
              <li
                class="pointer text-body-secondary fw-semibold transition position-relative"
                role="button"
                tabindex="0"
                @click="$emit('request-logout')"
                @keydown.enter.prevent="$emit('request-logout')"
                @keydown.space.prevent="$emit('request-logout')"
              >
                <i class="flaticon-logout"></i>
                Deslogar
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, onBeforeUnmount } from "vue";
import { mapGetters } from "vuex";
import LightDarkSwtichBtn from "./LightDarkSwtichBtn.vue";
import stateStore from "../../utils/store";

export default defineComponent({
  name: "MainHeader",
  emits: ["request-logout"],
  components: {
    LightDarkSwtichBtn,
  },
  setup() {
    const stateStoreInstance = stateStore;
    const isSticky = ref(false);
    const onScroll = () => (isSticky.value = window.scrollY >= 100);

    onMounted(() => {
      window.addEventListener("scroll", onScroll);
    });

    onBeforeUnmount(() => {
      window.removeEventListener("scroll", onScroll);
    });

    return {
      isSticky,
      stateStoreInstance,
    };
  },
  computed: {
    ...mapGetters([
      "getConfigurations",
    ]),
  },
});
</script>

<style scoped>
.custom-pre-header {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
}

.custom-option-right {
  display: flex !important;
  flex-wrap: nowrap;
}

.header-context {
  color: #656f7d;
  font-size: 14px;
  font-weight: 700;
  margin-left: 14px;
}
</style>
